import styled from 'styled-components'

export const Container = styled.div`
  padding: 10px 0;
`

export const Header = styled.h3`
  margin: 0 0 16px 0;
  && {
    font-size: ${props => props.theme.font.size.base};
  }
`

export const Disclaimer = styled.p`
  font-style: italic;
`
